export const CLASS_NAMES = {
  footer: "flex flex-1 justify-end w-full",
};

export const SAVE_BUTTON = "Confirm & Save";
